/**
 * Barra superior YASY: rotação das mensagens, cópia de cupom e contagem regressiva.
 *
 * Sem dependências. A rotação respeita prefers-reduced-motion e pausa enquanto
 * a pessoa está com o mouse ou o foco dentro da barra.
 */
(function () {
  function ligar(barra) {
    if (!barra || barra.dataset.yasyLigado) return;
    barra.dataset.yasyLigado = '1';

    var slides = Array.prototype.slice.call(barra.querySelectorAll('[data-yasy-anuncio-slide]'));
    var status = barra.querySelector('[data-yasy-anuncio-status]');
    var atual = 0;
    var timer = null;
    var intervalo = parseInt(barra.dataset.intervalo, 10) || 6000;
    var reduzirMovimento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // ------------------------------------------------------------- rotação
    // as duas paletas que a barra alterna a cada aviso
    var temaA = (barra.dataset.temaA || '').split(' ').filter(Boolean);
    var temaB = (barra.dataset.temaB || '').split(' ').filter(Boolean);

    // conta as trocas, não o índice do aviso: com um número ímpar de avisos,
    // alternar por índice repetiria a cor toda vez que a lista dá a volta
    var trocas = 0;

    function aplicarTema() {
      if (!temaA.length || !temaB.length) return;
      var entra = trocas % 2 === 0 ? temaA : temaB;
      var sai = trocas % 2 === 0 ? temaB : temaA;
      sai.forEach(function (c) { if (entra.indexOf(c) === -1) barra.classList.remove(c); });
      entra.forEach(function (c) { barra.classList.add(c); });

      // informa aos cards do contador qual é o fundo atual, para o número
      // usar essa cor (bg-doceDeLeite -> --yasy-doce-de-leite)
      var classeFundo = entra.filter(function (c) { return c.indexOf('bg-') === 0; })[0];
      if (classeFundo) {
        var token = classeFundo.slice(3).replace(/([A-Z])/g, function (m) { return '-' + m.toLowerCase(); });
        barra.style.setProperty('--yasy-anuncio-fundo', 'rgb(var(--yasy-' + token + '))');
      }
    }

    function mostrar(indice) {
      if (slides.length === 0) return;
      atual = (indice + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.hidden = i !== atual; });
      aplicarTema();
      trocas++;
      if (status) status.textContent = 'Aviso ' + (atual + 1) + ' de ' + slides.length;
    }

    function proximo() { mostrar(atual + 1); }
    function anterior() { mostrar(atual - 1); }

    function iniciar() {
      if (reduzirMovimento || slides.length < 2 || timer) return;
      timer = setInterval(proximo, intervalo);
    }
    function parar() { if (timer) { clearInterval(timer); timer = null; } }

    var btnAnterior = barra.querySelector('[data-yasy-anuncio-anterior]');
    var btnProximo = barra.querySelector('[data-yasy-anuncio-proximo]');
    if (btnAnterior) btnAnterior.addEventListener('click', function () { parar(); anterior(); iniciar(); });
    if (btnProximo) btnProximo.addEventListener('click', function () { parar(); proximo(); iniciar(); });

    barra.addEventListener('mouseenter', parar);
    barra.addEventListener('mouseleave', iniciar);
    barra.addEventListener('focusin', parar);
    barra.addEventListener('focusout', iniciar);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) parar(); else iniciar();
    });

    mostrar(0);
    iniciar();

    // -------------------------------------------------------------- cupom
    Array.prototype.forEach.call(barra.querySelectorAll('[data-yasy-cupom]'), function (botao) {
      var alvo = botao.querySelector('[data-yasy-cupom-texto]');
      var original = alvo ? alvo.textContent : '';
      botao.addEventListener('click', function () {
        var codigo = botao.getAttribute('data-yasy-cupom');
        var confirmar = function () {
          if (!alvo) return;
          alvo.textContent = 'Copiado!';
          if (status) status.textContent = 'Cupom ' + codigo + ' copiado';
          setTimeout(function () { alvo.textContent = original; }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(codigo).then(confirmar).catch(copiarLegado);
        } else {
          copiarLegado();
        }
        function copiarLegado() {
          // navegadores sem Clipboard API (ou sem HTTPS)
          var campo = document.createElement('textarea');
          campo.value = codigo;
          campo.setAttribute('readonly', '');
          campo.style.cssText = 'position:absolute;left:-9999px';
          document.body.appendChild(campo);
          campo.select();
          try { document.execCommand('copy'); confirmar(); } catch (e) { /* silencioso */ }
          campo.remove();
        }
      });
    });

    // ---------------------------------------------------------- contador
    var contadores = Array.prototype.slice.call(barra.querySelectorAll('[data-yasy-contador]'));
    if (contadores.length) {
      var pad = function (n) { return n < 10 ? '0' + n : String(n); };

      var escreverGrupo = function (raiz, nome, valor) {
        var grupo = raiz.querySelector('[data-grupo="' + nome + '"]');
        if (!grupo) return;
        var alvo = grupo.querySelector('[data-valor]');
        if (!alvo) return;
        var texto = pad(valor);
        // só toca no DOM quando o número muda, para não repintar a cada segundo
        if (alvo.textContent !== texto) alvo.textContent = texto;
      };

      var tick = function () {
        contadores.forEach(function (el) {
          var cards = el.querySelector('[data-yasy-contador-cards]');
          var fim = el.querySelector('[data-yasy-contador-fim]');

          var bruto = (el.getAttribute('data-yasy-contador') || '').trim().replace(' ', 'T');
          var alvo = new Date(bruto);
          if (isNaN(alvo.getTime())) return;

          var restante = alvo.getTime() - Date.now();
          if (restante <= 0) {
            if (cards) cards.hidden = true;
            if (fim) fim.hidden = false;
            return;
          }
          if (cards) cards.hidden = false;
          if (fim) fim.hidden = true;

          var s = Math.floor(restante / 1000);
          escreverGrupo(el, 'dias', Math.floor(s / 86400));
          escreverGrupo(el, 'horas', Math.floor((s % 86400) / 3600));
          escreverGrupo(el, 'minutos', Math.floor((s % 3600) / 60));
          escreverGrupo(el, 'segundos', s % 60);
        });
      };
      tick();
      setInterval(tick, 1000);
    }
  }

  function iniciarTodos(raiz) {
    Array.prototype.forEach.call((raiz || document).querySelectorAll('[data-yasy-anuncio]'), ligar);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { iniciarTodos(); });
  else iniciarTodos();
  document.addEventListener('shopify:section:load', function (e) { iniciarTodos(e.target); });
})();
